import React from "react";
import './Backdrop.css';

const Backdrop = (props) => {
  return (
    <>
      {props.open
        ? <div className="backdrop">{props.children}</div>
        : <div></div>
      }
    </>
  );
}

export default Backdrop;